import {useLocation} from 'react-router';
import {Link} from './ScopedLink';
import {selectedBuilding} from './building-scope';
import {complianceReturnContext} from './compliance-navigation';
export function ComplianceReturnLink(){const location=useLocation(),building=selectedBuilding(location.pathname,location.search),context=complianceReturnContext(location.state,building);
  if(!building&&!context)return null;
  return <Link className="back-link" to={context?.to??'/compliance'} state={context?{complianceFocusKey:context.focusKey}:undefined}>Return to Compliance</Link>;
}
